import { indexItems } from '@/mocks/home';

export default function Index() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          分类索引
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <div key={i} className="group cursor-pointer">
              <div className="relative aspect-[16/10] rounded-xl overflow-hidden mb-3">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-medium bg-background-50/90 text-foreground-800 rounded-md whitespace-nowrap">
                    {item.count} 部
                  </span>
                </div>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 text-center group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}